import { linearProgressClasses } from '@mui/material/LinearProgress';
import DEFAULT_PROGRESS_BAR_CLASS_NAME from '../../constants/linear-progress';

const defaultProgressBar = ({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main,
  },
});

const MuiLinearProgress = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DEFAULT_PROGRESS_BAR_CLASS_NAME}`]: defaultProgressBar({ theme }),
    }),
  },
};

export default MuiLinearProgress;
